/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). Neutral fill, not an accent color, so a search
   match reads as "found" without implying status/importance. */

.mark {
  background: var(--color-background-gray);
  color: inherit;
  border-radius: var(--radius-sm);
}
